import { render, staticRenderFns } from "./VsPagination.vue?vue&type=template&id=fd4625b0"
import script from "./VsPagination.vue?vue&type=script&lang=js"
export * from "./VsPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports